"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_use_1 = require("react-use");
const immutable_1 = require("immutable");
const Box_1 = __importDefault(require("@mui/material/Box"));
const selectors_1 = require("data/payees/selectors");
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const QTypography_1 = __importDefault(require("components/MUIWrappers/QTypography"));
const FilteredInput_1 = __importDefault(require("./FilteredInput"));
const emptyList = (0, immutable_1.List)();
const PayeeFieldEditable = (props) => {
    const { menuShowFields = 'payee', width = 'auto' } = props;
    const [stateValue, setStateValue] = (0, react_1.useState)(props.value);
    const prevPayeeValue = (0, react_use_1.usePrevious)(props.value.payee);
    const payeeList = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getPayeesAsList)(state, Object.assign(Object.assign({}, props), { accountIds: (props === null || props === void 0 ? void 0 : props.useAllAccounts) ? null : props.accountIds })));
    let inputRef = null;
    const menuOnChange = (item) => {
        if (props.onChange) {
            props.onChange({ target: { value: item } });
        }
    };
    const onChangeInput = (event) => {
        if (props.onChange) {
            props.onChange({ target: { value: { name: event.target.value } } });
        }
    };
    (0, react_1.useEffect)(() => {
        if (props.initialFocus && inputRef) {
            inputRef.focus();
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0, react_1.useEffect)(() => {
        if (props.value.payee !== prevPayeeValue) {
            setStateValue((prevState) => (Object.assign(Object.assign({}, prevState), { payee: props.value.payee })));
        }
    }, [props.value, prevPayeeValue]);
    return (<>
      {props.editable &&
            <Box_1.default display="flex" width={width}>
          <FilteredInput_1.default placeholder={props.placeholder} label={props.label} data={payeeList || emptyList} value={stateValue.payee} onChange={menuOnChange} onChangeInput={onChangeInput} onBlur={props.onBlur} name={props.name || 'payeelist'} disableUnderline={props.disableUnderline} autoFocus={props.autoFocus} menuPosition={props.menuPosition} textFieldProps={props.textFieldProps} textFieldVariant={props.textFieldVariant} marginProp={props.marginProp} inputRef={(x) => {
                    if (props.inputRef) {
                        props.inputRef(x);
                    }
                    inputRef = x;
                }} fontSize={props.fontSize} menuShowFields={menuShowFields} width={width}/>
        </Box_1.default>}
      {!props.editable &&
            <QTip_1.default wrapOnly title={props.tooltip ? stateValue.payee : null}>
          <QTypography_1.default type="body1" clickable={props.clickable} thinFont className={props.classNameWhenNotEditable}>
            {stateValue.payee}
          </QTypography_1.default>
        </QTip_1.default>}
    </>);
};
exports.default = react_1.default.memo(PayeeFieldEditable);
